import { render, staticRenderFns } from "./ExpedientesMain.vue?vue&type=template&id=22a2be9e&scoped=true&"
import script from "./ExpedientesMain.vue?vue&type=script&lang=js&"
export * from "./ExpedientesMain.vue?vue&type=script&lang=js&"
import style1 from "./ExpedientesMain.vue?vue&type=style&index=1&id=22a2be9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2be9e",
  null
  
)

export default component.exports